import React, { useState } from 'react';
import { getFullNameByEmail } from '../../App';

const AdminChangeRequests = ({ tickets, users, onUpdateStatus }) => {
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPriority, setFilterPriority] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const changeTickets = tickets.filter(ticket => ticket.type === 'degisim');

  const filteredTickets = changeTickets.filter(ticket => {
    const matchesStatus = filterStatus === 'all' || ticket.status === filterStatus;
    const matchesPriority = filterPriority === 'all' || ticket.priority === filterPriority;
    const matchesSearch = ticket.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         ticket.user_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (ticket.product_name && ticket.product_name.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesStatus && matchesPriority && matchesSearch;
  });

  const getStatusLabel = (status) => {
    const labels = {
      open: '🔴 Beklemede',
      in_progress: '🟡 Değerlendiriliyor',
      closed: '🟢 Tamamlandı',
      procurement: '🟣 Tedarik Sürecinde'
    };
    return labels[status] || status;
  };

  const getPriorityLabel = (priority) => {
    const labels = {
      low: '🟢 Düşük',
      normal: '🟡 Normal',
      high: '🟠 Yüksek',
      urgent: '🔴 Acil'
    };
    return labels[priority] || priority;
  };

  const getStatusStats = () => {
    return {
      total: changeTickets.length,
      open: changeTickets.filter(t => t.status === 'open').length,
      inProgress: changeTickets.filter(t => t.status === 'in_progress').length,
      closed: changeTickets.filter(t => t.status === 'closed').length
    };
  };

  // Stat karta tıklandığında filtreyi değiştir
  const handleStatClick = (status) => {
    setFilterStatus(status);
  };

  const stats = getStatusStats();

  return (
    <div className="admin-change-requests">
      <div className="change-requests-header">
        <h3>Değişim Talepleri ({changeTickets.length})</h3>
        
        {/* İstatistikler - Tıklanabilir */}
        <div className="change-stats-grid">
          <div 
            className={`change-stat-item total ${filterStatus === 'all' ? 'active' : ''}`}
            onClick={() => handleStatClick('all')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.total}</span>
            <span className="stat-label">Toplam</span>
          </div>
          <div 
            className={`change-stat-item pending ${filterStatus === 'open' ? 'active' : ''}`}
            onClick={() => handleStatClick('open')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.open}</span>
            <span className="stat-label">Beklemede</span>
          </div>
          <div 
            className={`change-stat-item review ${filterStatus === 'in_progress' ? 'active' : ''}`}
            onClick={() => handleStatClick('in_progress')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.inProgress}</span>
            <span className="stat-label">Değerlendiriliyor</span>
          </div>
          <div 
            className={`change-stat-item completed ${filterStatus === 'closed' ? 'active' : ''}`}
            onClick={() => handleStatClick('closed')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.closed}</span>
            <span className="stat-label">Tamamlandı</span>
          </div>
        </div>
      </div>

      {/* Filtreler */}
      <div className="change-filters">
        <div className="filter-group">
          <input
            type="text"
            placeholder="Değişim talebi ara... (başlık, kullanıcı, ürün)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="filter-group">
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">Tüm Durumlar</option>
            <option value="open">Beklemede</option>
            <option value="in_progress">Değerlendiriliyor</option>
            <option value="closed">Tamamlandı</option>
          </select>
        </div>

        <div className="filter-group">
          <select
            value={filterPriority}
            onChange={(e) => setFilterPriority(e.target.value)}
            className="filter-select"
          >
            <option value="all">Tüm Öncelikler</option>
            <option value="urgent">Acil</option>
            <option value="high">Yüksek</option>
            <option value="normal">Normal</option>
            <option value="low">Düşük</option>
          </select>
        </div>
      </div>

      {/* Değişim Talepleri Listesi */}
      {filteredTickets.length === 0 ? (
        <div className="no-data">
          {searchTerm || filterStatus !== 'all' || filterPriority !== 'all' 
            ? 'Filtrelere uygun değişim talebi bulunamadı.' 
            : 'Henüz hiç değişim talebi bulunmuyor.'}
        </div>
      ) : (
        <div className="change-tickets-list">
          {filteredTickets.map(ticket => (
            <div key={ticket.id} className={`change-ticket-card priority-${ticket.priority} status-${ticket.status}`}>
              <div className="change-ticket-header">
                <div className="change-info">
                  <h4>{ticket.title}</h4>
                  <div className="change-meta">
                    <span className="change-user">👤 {getFullNameByEmail(ticket.user_email, users)}</span>
                    <span className="change-date">📅 {new Date(ticket.created_at).toLocaleDateString('tr-TR')}</span>
                  </div>
                </div>
                <div className="change-badges">
                  <span className={`priority-badge ${ticket.priority}`}>
                    {getPriorityLabel(ticket.priority)}
                  </span>
                  <span className={`status-badge ${ticket.status}`}>
                    {getStatusLabel(ticket.status)}
                  </span>
                </div>
              </div>

              {ticket.product_name && (
                <div className="change-product">
                  <strong>🔄 İlgili Ürün:</strong> {ticket.product_name} ({ticket.product_code})
                </div>
              )}

              <div className="change-description">
                <strong>📝 Talep Açıklaması:</strong>
                <p>{ticket.description}</p>
              </div>

              <div className="change-actions">
                <div className="status-update">
                  <label>Durum Güncelle:</label>
                  <div className="status-buttons">
                    <button 
                      onClick={() => onUpdateStatus(ticket.id, 'open')}
                      className={`btn-status-change ${ticket.status === 'open' ? 'active' : ''}`}
                    >
                      🔴 Beklemede
                    </button>
                    <button 
                      onClick={() => onUpdateStatus(ticket.id, 'in_progress')}
                      className={`btn-status-change ${ticket.status === 'in_progress' ? 'active' : ''}`}
                    >
                      🟡 Değerlendir
                    </button>
                    <button 
                      onClick={() => onUpdateStatus(ticket.id, 'closed')}
                      className={`btn-status-change ${ticket.status === 'closed' ? 'active' : ''}`}
                    >
                      🟢 Tamamla
                    </button>
                  </div>
                </div>
              </div>

              <div className="change-footer">
                <small>
                  Oluşturulma: {new Date(ticket.created_at).toLocaleString('tr-TR')}
                  {ticket.updated_at !== ticket.created_at && (
                    <> | Güncelleme: {new Date(ticket.updated_at).toLocaleString('tr-TR')}</>
                  )}
                </small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminChangeRequests;